function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#eb268d",
  d: "M0 42l583 53H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fill: "#eb26da",
  d: "M0 42l583 53V0L0 95z"
});

function SvgLyftVert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 583 95"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1ODMgOTUiPgogIDxwb2x5Z29uIHBvaW50cz0iMCw0MiA1ODMsOTUgMCw5NSIgZmlsbD0iI2ViMjY4ZCIvPgogIDxwb2x5Z29uIHBvaW50cz0iMCw0MiA1ODMsOTUgNTgzLDAgMCw5NSIgb3BhY2l0eT0iLjQiIGZpbGw9IiNlYjI2ZGEiLz4KPC9zdmc+";
export { SvgLyftVert as ReactComponent };